import { FadeLoader } from 'react-spinners'
import React from 'react'
import * as StyledComponent from '../styles'

const PageMiddleSpinner = (props, context) => <StyledComponent.PageMiddleSpinner>
  <FadeLoader key='loader' color={'#a3a3a3'} loading={props.loading} />
</StyledComponent.PageMiddleSpinner>

export default PageMiddleSpinner



// WEBPACK FOOTER //
// ./src/components/PageMiddleSpinner.js